import actions from './actions'
import newActions from '../newTrade/actions'

const initialState = {
  beneficiaryLoading: false,
  beneficiary: {},
  beneficiaries: [],
  pagination: {
    pageSize: 10,
    current: 1,
    total: 0,
  },
}

export default function beneficiaryReducer(state = initialState, action) {
  switch (action.type) {
    case newActions.GET_BENEFICIARY_CRYPTO_BY_CLIENT_ID_SUCCESS:
      return {
        ...state,
        beneficiaries: action.value.beneficiaries,
      }
    case actions.GET_BENEFICIARIES_BY_CLIENT_ID:
      return {
        ...state,
        beneficiaryLoading: true,
      }
    case actions.GET_BENEFICIARIES_BY_CLIENT_ID_SUCCESS:
      return {
        ...state,
        beneficiaryLoading: false,
        beneficiaries: action.value,
      }
    case actions.GET_BENEFICIARIES_BY_CLIENT_ID_FAILURE:
      return {
        ...state,
        beneficiaryLoading: false,
      }
    default:
      return state
  }
}
